import HeroText from "../../components/heros/hero-text";
import CardDefault from "../../components/ui/cards/card-default/card-default";
import "./termsAndConditions.scss";

const TermsAndConditions = () => {
  return (
    <div className="terms-and-conditions">
      <HeroText
        title={"Termini e Condizioni"}
        text={"Informazioni sui cookie utilizzati dal nostro sito web"}
      />
      <section className="terms-and-conditions__intro">
        <h2 className="terms-and-conditions__intro-title">
          Termini d'Uso di www.rotoinfissioni.it
        </h2>
        <p className="terms-and-conditions__last-update">
          <span>Ultimo aggiornamento:</span>
          <span>Agosto 2026</span>
        </p>
        <p className="terms-and-conditions__intro-text">
          L'accesso e l'utilizzo del Sito comportano l'accettazione dei presenti
          Termini e Condizioni da parte dell'utente.
        </p>
      </section>
      <section className="terms-and-conditions__section">
        <h2 className="terms-and-conditions__section-title">1. Oggetto</h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="terms-and-conditions__section-text">
            Il Sito ha finalità puramente informative riguardo ai prodotti, alle
            tecnologie e alle attività di Rotoinfissioni S.r.l. Non vengono
            offerti servizi online né raccolti dati personali tramite form o
            registrazioni.
          </p>
        </CardDefault>
      </section>
      <section className="terms-and-conditions__section">
        <h2 className="terms-and-conditions__section-title">
          2. Proprietà intellettuale
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="terms-and-conditions__section-text">
            Tutti i contenuti del Sito (testi, immagini, loghi, grafica, codice
            sorgente) sono di proprietà di Rotoinfissioni S.r.l. o dei
            rispettivi autori e sono protetti dalle leggi sul diritto d'autore.
          </p>
          <p className="terms-and-conditions__section-text">
            Il Sito utilizza risorse grafiche e librerie di icone fornite da:
          </p>
          <ul className="privacy-policy__list" style={{ marginBottom: "1rem" }}>
            <li>
              <span style={{ color: "#000000" }}>Font Awesome</span> (©
              Fonticons, Inc.) - licenza{" "}
              <a
                className="terms-and-conditions__list-link"
                href="https://creativecommons.org/licenses/by/4.0/"
                target="_blank"
                rel="noopener noreferrer"
              >
                CC BY 4.0
              </a>
              ;
            </li>
            <li>
              <span style={{ color: "#000000" }}>Google Fonts Icons</span> (©
              Google LLC) - licenza{" "}
              <a
                className="terms-and-conditions__list-link"
                href="https://www.apache.org/licenses/LICENSE-2.0"
                target="_blank"
                rel="noopener noreferrer"
              >
                Apache 2.0
              </a>
              .
            </li>
          </ul>
          <p className="terms-and-conditions__section-text">
            Tali elementi restano di proprietà dei rispettivi titolari e sono
            utilizzati nel rispetto delle relative licenze d'uso. È vietata la
            riproduzione, distribuzione o modifica dei contenuti senza
            autorizzazione scritta del Titolare.
          </p>
        </CardDefault>
      </section>
      <section className="terms-and-conditions__section">
        <h2 className="terms-and-conditions__section-title">
          3. Limitazione di responsabilità
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="terms-and-conditions__section-text">
            <span>
              Rotoinfissioni S.r.l. si impegna a mantenere aggiornate e accurate
              le informazioni presenti sul Sito, ma non garantisce l'assenza di
              errori o interruzioni.
            </span>
            <span>Non è responsabile per:</span>
          </p>
          <ul className="privacy-policy__list">
            <li>danni derivanti da uso improprio del sito;</li>
            <li>contenuti o servizi di terze parti (es. Google Maps).</li>
          </ul>
        </CardDefault>
      </section>
      <section className="terms-and-conditions__section">
        <h2 className="terms-and-conditions__section-title">
          4. Link e contenuti di terzi
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="terms-and-conditions__section-text">
            <span>
              Il Sito può contenere link o contenuti esterni (iframe, plugin,
              mappe).
            </span>
            <span>
              Tali risorse sono gestite da terze parti e soggette alle relative
              condizioni d'uso e informative privacy.
            </span>
          </p>
        </CardDefault>
      </section>
      <section className="terms-and-conditions__section">
        <h2 className="terms-and-conditions__section-title">5. Modifiche</h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="terms-and-conditions__section-text">
            Il Titolare può modificare in qualsiasi momento i presenti Termini,
            che entreranno in vigore alla pubblicazione sul Sito.
          </p>
        </CardDefault>
      </section>
      <section className="terms-and-conditions__section">
        <h2 className="terms-and-conditions__section-title">
          6. Legge applicabile e foro competente
        </h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="terms-and-conditions__section-text">
            <span>I presenti Termini sono regolati dalla legge italiana.</span>
            <span>
              Per eventuali controversie è competente il Foro di Padova
              (Italia).
            </span>
          </p>
        </CardDefault>
      </section>
      <section className="privacy-policy__section">
        <h2 className="privacy-policy__section-title">7. Contatti</h2>
        <CardDefault type={"grey"} width="full-width">
          <p className="privacy-policy__section-text">
            <span style={{ color: "#000000" }}>Rotoinfissioni S.r.l.</span>
            <span>
              Via Vittorio Emanuele II n.41/1 - 35026 Conselve (PD) - Italia
            </span>
            <span>Email: commerciale@rotoinfissioni.it</span>
            <span>PEC: rotoinfissionisrl@pec.it</span>
            <span>P.IVA: 04903730283</span>
          </p>
        </CardDefault>
      </section>
    </div>
  );
};

export default TermsAndConditions;
